export default __webpack_public_path__ + "static/media/page-yellow.998860e6.png";